import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import Main from 'components/AuthNew/LoginPage';
import SignUpLayoutNew from 'layouts/SignUpLayoutNew';
import MobileContext from 'context/MobileContext';

const LoginPageNew = props => {
  const isMobile = useContext(MobileContext);
  const [hasErrors, setHasErrors] = useState(false);

  // Function to handle errors from the login form
  const handleFormErrors = hasFormErrors => {
    setHasErrors(hasFormErrors);
  };

  return (
    <SignUpLayoutNew
      width={isMobile ? '100%' : 500}
      height={isMobile ? '100%' : hasErrors ? 620 : 600}
      isMobile={isMobile}
    >
      <Main isMobile={isMobile} onFormErrors={handleFormErrors} {...props} />
    </SignUpLayoutNew>
  );
};

LoginPageNew.propTypes = {
  login: PropTypes.func.isRequired,
};

LoginPageNew.defaultProps = {};

export default LoginPageNew;
